import EstimatedAttendanceModal from 'components/dashboard/EventInsights/CheckinManagerPage/EstimatedAttendanceModal';

/**
 * Due to tight timeline, temporarily re-exporting the component from the dashboard.
 *   - In future, we should rewrite the `EstimatedAttendanceModal` component using new @epoch-ui components.
 * TODO: Rewrite the `EstimatedAttendanceModal` component using new @epoch-ui components.
 */
const EventEstimatedAttendanceModal = EstimatedAttendanceModal;

export { EventEstimatedAttendanceModal };
